@if (!entityId()) {
  <p class="text-slate-500 py-6">Guarda el {{ entityLabel() }} para ver el historial de cambios.</p>
} @else {
  <div class="flex items-center justify-between mt-4 mb-4">
    <div>
      <h3 class="text-lg font-semibold text-slate-900">Auditoría</h3>
      <p class="text-sm text-slate-500">Historial de cambios registrados para este {{ entityLabel() }}.</p>
    </div>
    <p-button
      type="button"
      label="Actualizar"
      icon="pi pi-refresh"
      [outlined]="true"
      [loading]="loading()"
      [disabled]="loading()"
      (onClick)="load()"
    />
  </div>
  <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
    <p-table
      [value]="changes()"
      [loading]="loading()"
      dataKey="commitId"
      [lazy]="true"
      [paginator]="true"
      [totalRecords]="totalItems()"
      [first]="page() * pageSize()"
      [rows]="pageSize()"
      [rowsPerPageOptions]="pageSizeOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} cambios"
      (onLazyLoad)="onLazyLoad($event)"
      styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th class="text-left">Cambio</th>
          <th class="text-center hidden sm:table-cell">Operación</th>
          <th class="text-left">Autor</th>
          <th class="text-center">Fecha</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="px-6 py-6 text-center text-sm text-slate-500">
            @if (loading()) {
              Cargando auditoría...
            } @else {
              No hay cambios registrados.
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-change>
        <tr
          class="hover:bg-slate-50 transition-colors cursor-pointer"
          (click)="openDrawer(change)">
          <td class="text-left">
            <span class="flex items-center gap-2 text-sm font-medium text-slate-900">
              <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sky-600">
                <i class="pi pi-history"></i>
              </span>
              <span class="min-w-0">
                <span class="block truncate">Versión {{ change.version ?? '—' }}</span>
                <span class="block text-xs font-normal text-slate-400 mt-0.5">Snapshot</span>
              </span>
            </span>
          </td>
          <td class="text-center hidden sm:table-cell">
            <p-tag
              [value]="operationLabel(change.operation)"
              [severity]="operationSeverity(change.operation)"
            />
          </td>
          <td class="text-left text-sm text-slate-600">{{ change.author || '—' }}</td>
          <td class="text-center text-sm text-slate-600">
            {{ change.commitDate ? (change.commitDate | date:'dd/MM/yyyy HH:mm') : '—' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}

<p-drawer
  [visible]="drawerOpen()"
  position="right"
  (visibleChange)="onDrawerVisibleChange($event)"
  styleClass="audit-json-drawer !w-[min(92vw,72rem)]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <i class="pi pi-history text-base"></i>
        </span>
        <div class="min-w-0">
          <h3 class="text-lg font-semibold text-slate-900 flex items-center gap-2 flex-wrap">
            Comparación de versión
            @if (compare()?.version != null || selectedChange()?.version != null) {
              <span class="inline-flex items-center rounded-md bg-slate-200/80 px-2 py-0.5 text-xs font-semibold text-slate-700">
                v{{ compare()?.version ?? selectedChange()?.version }}
              </span>
            }
          </h3>
          @if (compare() || selectedChange(); as change) {
            <p class="text-xs text-slate-500 truncate">
              {{ operationLabel(change.operation) }}
              · {{ change.author || '—' }}
              · {{ change.commitDate ? (change.commitDate | date:'dd/MM/yyyy HH:mm') : '—' }}
            </p>
          }
        </div>
      </div>
      <div class="flex items-center gap-1 shrink-0">
        <p-button
          type="button"
          icon="pi pi-chevron-left"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          size="small"
          [disabled]="compareLoading() || !canGoOlderVersion()"
          (onClick)="goToPreviousVersion()"
          pTooltip="Versión anterior"
          tooltipPosition="bottom"
          appendTo="body"
        />
        <p-button
          type="button"
          icon="pi pi-chevron-right"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          size="small"
          [disabled]="compareLoading() || !canGoNewerVersion()"
          (onClick)="goToNextVersion()"
          pTooltip="Versión siguiente"
          tooltipPosition="bottom"
          appendTo="body"
        />
        <p-button
          type="button"
          label="Copiar JSON"
          icon="pi pi-copy"
          [outlined]="true"
          size="small"
          class="ml-1"
          (onClick)="copyJson()"
        />
      </div>
    </div>
  </ng-template>
  @if (compareLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Comparando con la versión anterior...</p>
    </div>
  } @else if (compare(); as compareResult) {
    <app-json-viewer
      [data]="compareResult.document"
      [previous]="compareResult.previousDocument"
    />
  }
</p-drawer>
